import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { updateClubSponsor, deleteClubSponsor } from '../actions';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

import Form from './Form';
import moment from 'moment';

const styles = theme => ({
  panel: {
    background: theme.palette.grey[100],
  },
  detail: {
    background: 'white',
    padding: 0,
    display: 'block',
  },
});

@connect()
@withStyles(styles)
export default class ClubSponsorsPanels extends Component {
  state = {
    expanded: null,
  };

  handleExpand = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  handleChange = id => data => {
    const { dispatch } = this.props;
    return dispatch(updateClubSponsor(id, data));
  };
  handleRemove = data => () => {
    const { dispatch } = this.props;
    return dispatch(deleteClubSponsor(data));
  };

  renderPanel = clubSponsor => {
    const { classes } = this.props;
    const { expanded } = this.state;

    if (!clubSponsor) return null;

    return (
      <ExpansionPanel
        expanded={expanded === clubSponsor.id}
        onChange={this.handleExpand(clubSponsor.id)}
        classes={{ root: classes.panel }}
      >
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>{this.renderTitle(clubSponsor)}</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails classes={{ root: classes.detail }}>
          {expanded === clubSponsor.id && (
            <Form
              onSubmit={this.handleChange(clubSponsor.id)}
              data={clubSponsor}
              onDelete={this.handleRemove(clubSponsor)}
            />
          )}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  };

  render() {
    const { sponsors = [] } = this.props;
    return sponsors.sort(this.sortClubSponsors).map(this.renderPanel);
  }

  renderTitle = clubSponsor => {
    let title = clubSponsor.typeTranslated;
    if (clubSponsor.startedAt) {
      const date = moment(clubSponsor.startedAt).format('L');
      title += ` (${date})`;
    }
    return title;
  };

  sortClubSponsors = (a, b) => {
    if (!a.startedAt) {
      return -1;
    }
    if (!b.startedAt) {
      return 1;
    }
    return a.startedAt < b.startedAt ? 1 : -1;
  };
}
